module.exports = __webpack_public_path__ + "img/01020208.bef3ce54.svg";